import moment from 'moment';
import SimulationReportNotification from './SimulationReportNotification';

export default class SimulationReport {
  constructor(data) {
    this.Id = data.Id;
    this.DecisionMakerId = data.DecisionMakerId;
    this.Options = data.Options;
    this.Entries = data.Entries;
    this.Error = data.Error;

    // Convert notifications array to Notification instances
    this.Notifications = data.Notifications ?
      data.Notifications.map(notificationData => new SimulationReportNotification(notificationData)) :
      [];

    this.Trades = data.Trades;
    this.TotalProfit = data.TotalProfit;

    // Use count fields from backend
    this.TradesCount = data.TradesCount || 0;
    this.NotificationsCount = data.NotificationsCount || 0;

    // Handle timestamp fields with moment.js
    if (data.StartTime !== undefined) {
      this.StartTime = (data.StartTime === null) ? null : moment.utc(data.StartTime);
    }

    if (data.EndTime !== undefined) {
      this.EndTime = (data.EndTime === null) ? null : moment.utc(data.EndTime);
    }
  }

  // Return formatted local time strings for display
  getStartTime() {
    return this.StartTime ? this.StartTime.local().format('L LTS') : '';
  }

  getEndTime() {
    return this.EndTime ? this.EndTime.local().format('L LTS') : '';
  }

  // Calculate and format duration
  getDuration() {
    if (!this.StartTime || !this.EndTime) return '';

    const diffMs = this.EndTime.valueOf() - this.StartTime.valueOf();
    const diffSeconds = Math.floor(diffMs / 1000);
    const hours = Math.floor(diffSeconds / 3600);
    const minutes = Math.floor((diffSeconds % 3600) / 60);
    const seconds = diffSeconds % 60;

    if (hours > 0) {
      return `${hours}h ${minutes}m ${seconds}s`;
    } else if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    } else {
      return `${seconds}s`;
    }
  }

  // Get status based on error field
  getStatus() {
    return this.Error ? 'Error' : 'Success';
  }

  getStatusBadgeClass() {
    return this.Error ? 'custom-badge-danger' : 'custom-badge-success';
  }

  // Get counts for display
  getTradesCount() {
    // Use the count from backend, fallback to array length for backward compatibility
    return this.TradesCount !== undefined ? this.TradesCount : (this.Trades ? this.Trades.length : 0);
  }

  getNotificationsCount() {
    // Use the count from backend, fallback to array length for backward compatibility
    return this.NotificationsCount !== undefined ? this.NotificationsCount : (this.Notifications ? this.Notifications.length : 0);
  }

  // Format profit for display
  getTotalProfit() {
    return this.TotalProfit || 0;
  }

  getFormattedProfit() {
    const profit = this.getTotalProfit();
    return `$${profit.toFixed(2)}`;
  }

  getProfitBadgeClass() {
    const profit = this.getTotalProfit();
    if (profit > 0) return 'custom-badge-profit';
    if (profit < 0) return 'custom-badge-loss';
    return 'custom-badge-neutral';
  }
}